var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"start-button"},[_vm._t("default",function(){return [_c('img',{attrs:{"src":require("../assets/img/play.png"),"height":"90px"}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }